import { render, staticRenderFns } from "./AccessRole.vue?vue&type=template&id=2c21ec73&scoped=true&"
import script from "./AccessRole.vue?vue&type=script&lang=js&"
export * from "./AccessRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c21ec73",
  null
  
)

export default component.exports